module.exports = __webpack_public_path__ + "img/intro_phone1.f7f60fa7.png";